import { render } from "./CreatePage.vue?vue&type=template&id=5bdffff2&ts=true"
import script from "./CreatePage.vue?vue&type=script&lang=ts"
export * from "./CreatePage.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/app/releases/1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__